import type { CapitalGlobalProposalStepProps } from '@/features/proposals/components/capital-global/capital-global-proposal-step.types';
import { CapitalGlobalProposalStep1FormProvider } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step1-form.context';
import type { CapitalGlobalProposalStep1FormApi } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step1-form.types';
import { CapitalGlobalProposalPrivacyConsentSection } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-privacy-consent-section.component';
import { CapitalGlobalProposalQuotationDataSection } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-quotation-data-section.component';
import { CapitalGlobalProposalStepDadosDoSeguroFooter } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-step-dados-do-seguro-footer.component';
import { CapitalGlobalProposalStipulantCompanyRegistrationSection } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-stipulant-company-registration-section.component';
import { CapitalGlobalProposalStipulantContactSection } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-stipulant-contact-section.component';
import { CapitalGlobalProposalStipulantCorrespondenceSection } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-stipulant-correspondence-section.component';
import { CapitalGlobalProposalSubStipulantAddressesSection } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-sub-stipulant-addresses-section.component';
import { useCapitalGlobalProposalStep1ViewModel } from '@/features/proposals/hooks/capital-global/use-capital-global-proposal-step1-view-model.hook';
import { useProposalForm } from '@/features/proposals/hooks/use-proposal-form.hook';
import { capitalGlobalProposalStepDadosDoSeguroDefaultValues } from '@/features/proposals/schemas/capital-global/proposal-step-dados-do-seguro.schema';

export function StepCapitalGlobalDadosDoSeguro({
  proposal,
  policyId,
  isViewMode,
  onNext,
  onBack,
  canGoNext,
  canGoBack,
}: CapitalGlobalProposalStepProps) {
  const form = useProposalForm({
    defaultValues: capitalGlobalProposalStepDadosDoSeguroDefaultValues,
    onSubmit: async () => {},
  }) as unknown as CapitalGlobalProposalStep1FormApi;

  const vm = useCapitalGlobalProposalStep1ViewModel({
    form,
    proposal,
    policyId,
    isViewMode,
    onNext,
    onBack,
    canGoNext,
    canGoBack,
  });

  return (
    <CapitalGlobalProposalStep1FormProvider
      value={{
        form,
        isViewMode,
        canGoNext,
        canGoBack,
        onBack,
        ...vm,
      }}
    >
      <div className='flex flex-col gap-10'>
        <CapitalGlobalProposalQuotationDataSection />
        <div className='flex flex-col gap-6'>
          <CapitalGlobalProposalStipulantCompanyRegistrationSection />
          <CapitalGlobalProposalStipulantCorrespondenceSection />
          <CapitalGlobalProposalStipulantContactSection />
        </div>
        <CapitalGlobalProposalSubStipulantAddressesSection />
        <CapitalGlobalProposalPrivacyConsentSection />
        <CapitalGlobalProposalStepDadosDoSeguroFooter />
      </div>
    </CapitalGlobalProposalStep1FormProvider>
  );
}
